import { Box, styled } from "@mui/material";

export const ContainerStyled = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  backgroundColor: "#F7F7F7",
  borderRadius: "8px",
  paddingBottom: "24px",
  position: "relative",
}));

export const ContainerCard = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  border: "1px solid #D4D4D4",
  borderRadius: "16px",
  padding: "0",
  color: "#121212",
  minWidth: "300px",
  maxWidth: "400px",
}));

export const ContainerTitleStyled = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  borderBottom: "1px solid #D4D4D4",
  padding: "16px",
}));
